<template>
    <div>
        <section
            style="position: relative;height:100vh;overflow: hidden;background-color: #444;font-family: sans-serif;">
            <div class="mask rgba-stylish-strong h-100 d-flex justify-content-center align-items-center">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-5 col-lg-6 col-md-10 col-sm-12 mx-auto">
                            <div class="card fadeIn" style="background-color: #3e4551b3 !important;">
                                <div class="card-body">
                                    <div class="form-header red-gradient">
                                        <h3 class="font-weight-500 my-2 py-1" style="font-size: 28px;"><i
                                                class="fas fa-user"></i>Ingreso
                                        </h3>
                                    </div>
                                    <form @submit.prevent="login()">
                                        <div v-if="status.type == 'danger'" style="color:red;">{{ status.message }}
                                        </div>
                                        <div class="md-form" style="color:white !important">
                                            <i class="fas fa-user prefix white-text"
                                                style="left:0;color:white !important"></i>
                                            <input style="color:white !important" v-model="username" type="text"
                                                id="user" class="form-control" autocomplete="off" required
                                                @focus="usernameFocused = true" @blur="usernameFocused = false">
                                            <label style="color:white !important" for="user"
                                                :class="{ active: usernameFocused || username}">Nombre de
                                                usuario</label>
                                        </div>
                                        <div class="md-form" style="color:white !important">
                                            <i class="fas fa-lock prefix" style="left:0;color:white !important"></i>
                                            <input style="color:white !important" v-model="password" type="password"
                                                id="passwd" class="form-control" autocomplete="off" required
                                                @focus="passwordFocused = true" @blur="passwordFocused = false">
                                            <label style="color:white !important" for="passwd"
                                                :class="{ active: passwordFocused || password }">Contraseña</label>
                                        </div>
                                        <div class="text-center">
                                            <div class="col-12 mt-3 mb-3 text-center" id="error"></div>
                                        </div>
                                        <div class="text-center">
                                            <button type="submit"
                                                class="btn red-gradient btn-lg waves-effect waves-light" id="dologin"
                                                data-loading="<i class='fa fa-spinner fa-spin '></i> Ingresando...">Ingresar</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    name: 'LoginSecond',
    props: ['translation', 'language'],
    components: {
    },
    data() {
        return {
            username: "",
            password: "",
            resetPassword: false,
            usernameFocused: false,
            passwordFocused: false,
            status: {
                message: "",
                type: ""
            },
            login_inProcess: false
        }
    },
    methods: {
        async login() {
            this.login_inProcess = true;
            if (this.resetPassword) {
                if (this.username != "") {
                    let reset = await axios.post(this.$store.getters["getDomain"] + "/swarm/remote/forgot_password", {
                        "email": this.username
                    })
                    if (reset.data.success) {
                        this.status.message = reset.data.message;
                        this.status.type = "success";
                    }
                    else {
                        this.status.message = reset.data.message;
                        this.status.type = "danger";
                    }
                    this.resetPassword = false;
                }
                else {
                    this.status.message = this.translate("input_email");
                    this.status.type = "danger";
                }
                this.login_inProcess = false;
            }
            else {
                let data = await this.$store.dispatch('login', { username: this.username, password: this.password });
                if (data == "success") {
                    this.$root.$emit('forceRender');
                    this.login_inProcess = false;
                    this.username = '';
                    this.password = '';
                    this.status.message = '';
                }
                else {
                    this.status.message = data;
                    this.status.type = "danger";
                    this.login_inProcess = false;
                }
            }

        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
    }
}
</script>
<style scoped>
.login-page .card {
    background-color: rgba(229, 228, 255, .2);
    margin-top: 30px;
}

.card {
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .16), 0 2px 10px 0 rgba(0, 0, 0, .12);
    border: 0;
    font-weight: 400;
}

.btn.btn-lg {
    padding: 1rem 2.4rem;
    font-size: .94rem
}

.btn {
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .16), 0 2px 10px 0 rgba(0, 0, 0, .12);
    padding: .84rem 2.14rem;
    font-size: .81rem;
    -webkit-transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
    -o-transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
    margin: .375rem;
    border: 0;
    -webkit-border-radius: .125rem;
    border-radius: .125rem;
    cursor: pointer;
    text-transform: uppercase;
    white-space: normal;
    word-wrap: break-word;
    color: #fff
}

.red-gradient {
    background: -webkit-linear-gradient(50deg, #292d3d, #03040d) !important;
    background: -o-linear-gradient(50deg, #292d3d, #03040d) !important;
    background: linear-gradient(40deg, #292d3d, #03040d) !important
}

.form-header {
    -webkit-box-shadow: 0 5px 11px 0 rgba(0, 0, 0, .18), 0 4px 15px 0 rgba(0, 0, 0, .15);
    box-shadow: 0 5px 11px 0 rgba(0, 0, 0, .18), 0 4px 15px 0 rgba(0, 0, 0, .15);
    color: #fff;
    text-align: center;
    margin-top: -3.13rem;
    margin-bottom: 3rem;
    padding: 1rem;
    -webkit-border-radius: .125rem;
    border-radius: .125rem
}

.md-form {
    position: relative;
    margin-bottom: 1.5rem
}

.md-form input[type=date],
.md-form input[type=datetime-local],
.md-form input[type=email],
.md-form input[type=number],
.md-form input[type=password],
.md-form input[type=search-md],
.md-form input[type=search],
.md-form input[type=tel],
.md-form input[type=text],
.md-form input[type=time],
.md-form input[type=url],
.md-form textarea.md-textarea {
    -webkit-transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
    -o-transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    border: none;
    border-bottom: 1px solid #ced4da;
    -webkit-border-radius: 0;
    border-radius: 0;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    background-color: transparent
}

.md-form input[type=date]:focus:not([readonly]),
.md-form input[type=datetime-local]:focus:not([readonly]),
.md-form input[type=email]:focus:not([readonly]),
.md-form input[type=number]:focus:not([readonly]),
.md-form input[type=password]:focus:not([readonly]),
.md-form input[type=search-md]:focus:not([readonly]),
.md-form input[type=search]:focus:not([readonly]),
.md-form input[type=tel]:focus:not([readonly]),
.md-form input[type=text]:focus:not([readonly]),
.md-form input[type=time]:focus:not([readonly]),
.md-form input[type=url]:focus:not([readonly]),
.md-form textarea.md-textarea:focus:not([readonly]) {
    -webkit-box-shadow: 0 1px 0 0 #fff;
    box-shadow: 0 1px 0 0 #fff;
    border-bottom: 1px solid #fff;
}

.md-form input[type=date]:focus:not([readonly])+label,
.md-form input[type=datetime-local]:focus:not([readonly])+label,
.md-form input[type=email]:focus:not([readonly])+label,
.md-form input[type=number]:focus:not([readonly])+label,
.md-form input[type=password]:focus:not([readonly])+label,
.md-form input[type=search-md]:focus:not([readonly])+label,
.md-form input[type=search]:focus:not([readonly])+label,
.md-form input[type=tel]:focus:not([readonly])+label,
.md-form input[type=text]:focus:not([readonly])+label,
.md-form input[type=time]:focus:not([readonly])+label,
.md-form input[type=url]:focus:not([readonly])+label,
.md-form textarea.md-textarea:focus:not([readonly])+label {
    color: #fff
}

.md-form input[type=date]+label:after,
.md-form input[type=datetime-local]+label:after,
.md-form input[type=email]+label:after,
.md-form input[type=number]+label:after,
.md-form input[type=password]+label:after,
.md-form input[type=search-md]+label:after,
.md-form input[type=search]+label:after,
.md-form input[type=tel]+label:after,
.md-form input[type=text]+label:after,
.md-form input[type=time]+label:after,
.md-form input[type=url]+label:after,
.md-form textarea.md-textarea+label:after {
    content: "";
    position: absolute;
    top: 65px;
    display: block;
    opacity: 0;
    -webkit-transition: .2s opacity ease-out, .2s color ease-out;
    -o-transition: .2s opacity ease-out, .2s color ease-out;
    transition: .2s opacity ease-out, .2s color ease-out
}

.md-form input[type=date].valid,
.md-form input[type=date]:focus.valid,
.md-form input[type=datetime-local].valid,
.md-form input[type=datetime-local]:focus.valid,
.md-form input[type=email].valid,
.md-form input[type=email]:focus.valid,
.md-form input[type=number].valid,
.md-form input[type=number]:focus.valid,
.md-form input[type=password].valid,
.md-form input[type=password]:focus.valid,
.md-form input[type=search-md].valid,
.md-form input[type=search-md]:focus.valid,
.md-form input[type=search].valid,
.md-form input[type=search]:focus.valid,
.md-form input[type=tel].valid,
.md-form input[type=tel]:focus.valid,
.md-form input[type=text].valid,
.md-form input[type=text]:focus.valid,
.md-form input[type=time].valid,
.md-form input[type=time]:focus.valid,
.md-form input[type=url].valid,
.md-form input[type=url]:focus.valid,
.md-form textarea.md-textarea.valid,
.md-form textarea.md-textarea:focus.valid {
    border-bottom: 1px solid #00c851;
    -webkit-box-shadow: 0 1px 0 0 #00c851;
    box-shadow: 0 1px 0 0 #00c851
}

.md-form input[type=date].valid+label:after,
.md-form input[type=date]:focus.valid+label:after,
.md-form input[type=datetime-local].valid+label:after,
.md-form input[type=datetime-local]:focus.valid+label:after,
.md-form input[type=email].valid+label:after,
.md-form input[type=email]:focus.valid+label:after,
.md-form input[type=number].valid+label:after,
.md-form input[type=number]:focus.valid+label:after,
.md-form input[type=password].valid+label:after,
.md-form input[type=password]:focus.valid+label:after,
.md-form input[type=search-md].valid+label:after,
.md-form input[type=search-md]:focus.valid+label:after,
.md-form input[type=search].valid+label:after,
.md-form input[type=search]:focus.valid+label:after,
.md-form input[type=tel].valid+label:after,
.md-form input[type=tel]:focus.valid+label:after,
.md-form input[type=text].valid+label:after,
.md-form input[type=text]:focus.valid+label:after,
.md-form input[type=time].valid+label:after,
.md-form input[type=time]:focus.valid+label:after,
.md-form input[type=url].valid+label:after,
.md-form input[type=url]:focus.valid+label:after,
.md-form textarea.md-textarea.valid+label:after,
.md-form textarea.md-textarea:focus.valid+label:after {
    content: attr(data-success);
    color: #00c851;
    opacity: 1
}

.md-form input[type=date].invalid,
.md-form input[type=date]:focus.invalid,
.md-form input[type=datetime-local].invalid,
.md-form input[type=datetime-local]:focus.invalid,
.md-form input[type=email].invalid,
.md-form input[type=email]:focus.invalid,
.md-form input[type=number].invalid,
.md-form input[type=number]:focus.invalid,
.md-form input[type=password].invalid,
.md-form input[type=password]:focus.invalid,
.md-form input[type=search-md].invalid,
.md-form input[type=search-md]:focus.invalid,
.md-form input[type=search].invalid,
.md-form input[type=search]:focus.invalid,
.md-form input[type=tel].invalid,
.md-form input[type=tel]:focus.invalid,
.md-form input[type=text].invalid,
.md-form input[type=text]:focus.invalid,
.md-form input[type=time].invalid,
.md-form input[type=time]:focus.invalid,
.md-form input[type=url].invalid,
.md-form input[type=url]:focus.invalid,
.md-form textarea.md-textarea.invalid,
.md-form textarea.md-textarea:focus.invalid {
    border-bottom: 1px solid #f44336;
    -webkit-box-shadow: 0 1px 0 0 #f44336;
    box-shadow: 0 1px 0 0 #f44336
}

.md-form input[type=date].invalid+label:after,
.md-form input[type=date]:focus.invalid+label:after,
.md-form input[type=datetime-local].invalid+label:after,
.md-form input[type=datetime-local]:focus.invalid+label:after,
.md-form input[type=email].invalid+label:after,
.md-form input[type=email]:focus.invalid+label:after,
.md-form input[type=number].invalid+label:after,
.md-form input[type=number]:focus.invalid+label:after,
.md-form input[type=password].invalid+label:after,
.md-form input[type=password]:focus.invalid+label:after,
.md-form input[type=search-md].invalid+label:after,
.md-form input[type=search-md]:focus.invalid+label:after,
.md-form input[type=search].invalid+label:after,
.md-form input[type=search]:focus.invalid+label:after,
.md-form input[type=tel].invalid+label:after,
.md-form input[type=tel]:focus.invalid+label:after,
.md-form input[type=text].invalid+label:after,
.md-form input[type=text]:focus.invalid+label:after,
.md-form input[type=time].invalid+label:after,
.md-form input[type=time]:focus.invalid+label:after,
.md-form input[type=url].invalid+label:after,
.md-form input[type=url]:focus.invalid+label:after,
.md-form textarea.md-textarea.invalid+label:after,
.md-form textarea.md-textarea:focus.invalid+label:after {
    content: attr(data-error);
    color: #f44336;
    opacity: 1
}

.md-form input[type=date].form-control.valid+label:after,
.md-form input[type=date].form-control:focus.valid+label:after,
.md-form input[type=datetime-local].form-control.valid+label:after,
.md-form input[type=datetime-local].form-control:focus.valid+label:after,
.md-form input[type=email].form-control.valid+label:after,
.md-form input[type=email].form-control:focus.valid+label:after,
.md-form input[type=number].form-control.valid+label:after,
.md-form input[type=number].form-control:focus.valid+label:after,
.md-form input[type=password].form-control.valid+label:after,
.md-form input[type=password].form-control:focus.valid+label:after,
.md-form input[type=search-md].form-control.valid+label:after,
.md-form input[type=search-md].form-control:focus.valid+label:after,
.md-form input[type=search].form-control.valid+label:after,
.md-form input[type=search].form-control:focus.valid+label:after,
.md-form input[type=tel].form-control.valid+label:after,
.md-form input[type=tel].form-control:focus.valid+label:after,
.md-form input[type=text].form-control.valid+label:after,
.md-form input[type=text].form-control:focus.valid+label:after,
.md-form input[type=time].form-control.valid+label:after,
.md-form input[type=time].form-control:focus.valid+label:after,
.md-form input[type=url].form-control.valid+label:after,
.md-form input[type=url].form-control:focus.valid+label:after,
.md-form textarea.md-textarea.form-control.valid+label:after,
.md-form textarea.md-textarea.form-control:focus.valid+label:after {
    top: 3.56rem
}

.md-form input[type=date].form-control.invalid+label:after,
.md-form input[type=date].form-control:focus.invalid+label:after,
.md-form input[type=datetime-local].form-control.invalid+label:after,
.md-form input[type=datetime-local].form-control:focus.invalid+label:after,
.md-form input[type=email].form-control.invalid+label:after,
.md-form input[type=email].form-control:focus.invalid+label:after,
.md-form input[type=number].form-control.invalid+label:after,
.md-form input[type=number].form-control:focus.invalid+label:after,
.md-form input[type=password].form-control.invalid+label:after,
.md-form input[type=password].form-control:focus.invalid+label:after,
.md-form input[type=search-md].form-control.invalid+label:after,
.md-form input[type=search-md].form-control:focus.invalid+label:after,
.md-form input[type=search].form-control.invalid+label:after,
.md-form input[type=search].form-control:focus.invalid+label:after,
.md-form input[type=tel].form-control.invalid+label:after,
.md-form input[type=tel].form-control:focus.invalid+label:after,
.md-form input[type=text].form-control.invalid+label:after,
.md-form input[type=text].form-control:focus.invalid+label:after,
.md-form input[type=time].form-control.invalid+label:after,
.md-form input[type=time].form-control:focus.invalid+label:after,
.md-form input[type=url].form-control.invalid+label:after,
.md-form input[type=url].form-control:focus.invalid+label:after,
.md-form textarea.md-textarea.form-control.invalid+label:after,
.md-form textarea.md-textarea.form-control:focus.invalid+label:after {
    top: 3.44rem
}

.md-form input[type=date].form-control-lg.valid+label:after,
.md-form input[type=date].form-control-lg:focus.valid+label:after,
.md-form input[type=datetime-local].form-control-lg.valid+label:after,
.md-form input[type=datetime-local].form-control-lg:focus.valid+label:after,
.md-form input[type=email].form-control-lg.valid+label:after,
.md-form input[type=email].form-control-lg:focus.valid+label:after,
.md-form input[type=number].form-control-lg.valid+label:after,
.md-form input[type=number].form-control-lg:focus.valid+label:after,
.md-form input[type=password].form-control-lg.valid+label:after,
.md-form input[type=password].form-control-lg:focus.valid+label:after,
.md-form input[type=search-md].form-control-lg.valid+label:after,
.md-form input[type=search-md].form-control-lg:focus.valid+label:after,
.md-form input[type=search].form-control-lg.valid+label:after,
.md-form input[type=search].form-control-lg:focus.valid+label:after,
.md-form input[type=tel].form-control-lg.valid+label:after,
.md-form input[type=tel].form-control-lg:focus.valid+label:after,
.md-form input[type=text].form-control-lg.valid+label:after,
.md-form input[type=text].form-control-lg:focus.valid+label:after,
.md-form input[type=time].form-control-lg.valid+label:after,
.md-form input[type=time].form-control-lg:focus.valid+label:after,
.md-form input[type=url].form-control-lg.valid+label:after,
.md-form input[type=url].form-control-lg:focus.valid+label:after,
.md-form textarea.md-textarea.form-control-lg.valid+label:after,
.md-form textarea.md-textarea.form-control-lg:focus.valid+label:after {
    top: 4.1rem
}

.md-form input[type=date].form-control-lg.invalid+label:after,
.md-form input[type=date].form-control-lg:focus.invalid+label:after,
.md-form input[type=datetime-local].form-control-lg.invalid+label:after,
.md-form input[type=datetime-local].form-control-lg:focus.invalid+label:after,
.md-form input[type=email].form-control-lg.invalid+label:after,
.md-form input[type=email].form-control-lg:focus.invalid+label:after,
.md-form input[type=number].form-control-lg.invalid+label:after,
.md-form input[type=number].form-control-lg:focus.invalid+label:after,
.md-form input[type=password].form-control-lg.invalid+label:after,
.md-form input[type=password].form-control-lg:focus.invalid+label:after,
.md-form input[type=search-md].form-control-lg.invalid+label:after,
.md-form input[type=search-md].form-control-lg:focus.invalid+label:after,
.md-form input[type=search].form-control-lg.invalid+label:after,
.md-form input[type=search].form-control-lg:focus.invalid+label:after,
.md-form input[type=tel].form-control-lg.invalid+label:after,
.md-form input[type=tel].form-control-lg:focus.invalid+label:after,
.md-form input[type=text].form-control-lg.invalid+label:after,
.md-form input[type=text].form-control-lg:focus.invalid+label:after,
.md-form input[type=time].form-control-lg.invalid+label:after,
.md-form input[type=time].form-control-lg:focus.invalid+label:after,
.md-form input[type=url].form-control-lg.invalid+label:after,
.md-form input[type=url].form-control-lg:focus.invalid+label:after,
.md-form textarea.md-textarea.form-control-lg.invalid+label:after,
.md-form textarea.md-textarea.form-control-lg:focus.invalid+label:after {
    top: 4rem
}

.md-form input[type=date].form-control-sm.valid+label:after,
.md-form input[type=date].form-control-sm:focus.valid+label:after,
.md-form input[type=datetime-local].form-control-sm.valid+label:after,
.md-form input[type=datetime-local].form-control-sm:focus.valid+label:after,
.md-form input[type=email].form-control-sm.valid+label:after,
.md-form input[type=email].form-control-sm:focus.valid+label:after,
.md-form input[type=number].form-control-sm.valid+label:after,
.md-form input[type=number].form-control-sm:focus.valid+label:after,
.md-form input[type=password].form-control-sm.valid+label:after,
.md-form input[type=password].form-control-sm:focus.valid+label:after,
.md-form input[type=search-md].form-control-sm.valid+label:after,
.md-form input[type=search-md].form-control-sm:focus.valid+label:after,
.md-form input[type=search].form-control-sm.valid+label:after,
.md-form input[type=search].form-control-sm:focus.valid+label:after,
.md-form input[type=tel].form-control-sm.valid+label:after,
.md-form input[type=tel].form-control-sm:focus.valid+label:after,
.md-form input[type=text].form-control-sm.valid+label:after,
.md-form input[type=text].form-control-sm:focus.valid+label:after,
.md-form input[type=time].form-control-sm.valid+label:after,
.md-form input[type=time].form-control-sm:focus.valid+label:after,
.md-form input[type=url].form-control-sm.valid+label:after,
.md-form input[type=url].form-control-sm:focus.valid+label:after,
.md-form textarea.md-textarea.form-control-sm.valid+label:after,
.md-form textarea.md-textarea.form-control-sm:focus.valid+label:after {
    top: 3.2rem
}

.md-form input[type=date].form-control-sm.invalid+label:after,
.md-form input[type=date].form-control-sm:focus.invalid+label:after,
.md-form input[type=datetime-local].form-control-sm.invalid+label:after,
.md-form input[type=datetime-local].form-control-sm:focus.invalid+label:after,
.md-form input[type=email].form-control-sm.invalid+label:after,
.md-form input[type=email].form-control-sm:focus.invalid+label:after,
.md-form input[type=number].form-control-sm.invalid+label:after,
.md-form input[type=number].form-control-sm:focus.invalid+label:after,
.md-form input[type=password].form-control-sm.invalid+label:after,
.md-form input[type=password].form-control-sm:focus.invalid+label:after,
.md-form input[type=search-md].form-control-sm.invalid+label:after,
.md-form input[type=search-md].form-control-sm:focus.invalid+label:after,
.md-form input[type=search].form-control-sm.invalid+label:after,
.md-form input[type=search].form-control-sm:focus.invalid+label:after,
.md-form input[type=tel].form-control-sm.invalid+label:after,
.md-form input[type=tel].form-control-sm:focus.invalid+label:after,
.md-form input[type=text].form-control-sm.invalid+label:after,
.md-form input[type=text].form-control-sm:focus.invalid+label:after,
.md-form input[type=time].form-control-sm.invalid+label:after,
.md-form input[type=time].form-control-sm:focus.invalid+label:after,
.md-form input[type=url].form-control-sm.invalid+label:after,
.md-form input[type=url].form-control-sm:focus.invalid+label:after,
.md-form textarea.md-textarea.form-control-sm.invalid+label:after,
.md-form textarea.md-textarea.form-control-sm:focus.invalid+label:after {
    top: 3.1rem
}

.md-form>input[type=date]:not(.browser-default)+label {
    -webkit-transform: translateY(-27px) scale(.8);
    -ms-transform: translateY(-27px) scale(.8);
    transform: translateY(-27px) scale(.8);
    -webkit-transform-origin: 0 0;
    -ms-transform-origin: 0 0;
    transform-origin: 0 0
}

.md-form>input[type=time]:not(.browser-default)+label,
.md-form>input[type]:-webkit-autofill:not(.browser-default):not([type=search])+label {
    -webkit-transform: translateY(-25px);
    transform: translateY(-25px);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    font-size: .8rem
}

.md-form .was-validated input[type=text]:valid+label {
    color: #00c851 !important
}

.md-form .was-validated input[type=text]:invalid+label {
    color: #f44336 !important
}

.md-form .was-validated .form-control:valid:focus {
    -webkit-box-shadow: 0 1px 0 0 #00c851 !important;
    box-shadow: 0 1px 0 0 #00c851 !important
}

.md-form .was-validated .form-control:valid {
    border-color: #00c851 !important
}

.md-form .was-validated .form-control:invalid:focus {
    -webkit-box-shadow: 0 1px 0 0 #f44336 !important;
    box-shadow: 0 1px 0 0 #f44336 !important
}

.md-form .was-validated .form-control:invalid {
    border-color: #f44336 !important
}

.md-form .form-control {
    margin: 0 0 .5rem;
    -webkit-border-radius: 0;
    border-radius: 0;
    padding: .3rem 0 .55rem;
    background-image: none;
    background-color: transparent;
    height: auto
}

.md-form .form-control:focus {
    -webkit-box-shadow: none;
    box-shadow: none;
    background: 0 0
}

.md-form .form-control:disabled,
.md-form .form-control[readonly] {
    border-bottom: 1px solid #bdbdbd;
    background-color: transparent
}

.md-form .validate {
    margin-bottom: 2.5rem
}

.md-form label.active {
    font-size: .8rem;
    -webkit-transform: translateY(-140%);
    -ms-transform: translateY(-140%);
    transform: translateY(-140%)
}

.md-form .prefix {
    top: .25rem;
    font-size: 1.75rem
}

.md-form .prefix~input,
.md-form .prefix~textarea {
    margin-left: 2.5rem;
    width: calc(100% - 2.5rem)
}

.md-form .prefix~label {
    margin-left: 2.5rem
}

.md-form .prefix~.form-text {
    margin-left: 2.6rem
}

.md-form label {
    position: absolute;
    top: .65rem;
    left: 0;
    -webkit-transition: .2s ease-out;
    -o-transition: .2s ease-out;
    transition: .2s ease-out;
    cursor: text;
    color: #757575
}

.md-form .prefix.active,
.md-form textarea~label.active,
.md-form.md-outline input[type=date]:focus:not([readonly])+label,
.md-form.md-outline input[type=datetime-local]:focus:not([readonly])+label,
.md-form.md-outline input[type=email]:focus:not([readonly])+label,
.md-form.md-outline input[type=number]:focus:not([readonly])+label,
.md-form.md-outline input[type=password]:focus:not([readonly])+label,
.md-form.md-outline input[type=search-md]:focus:not([readonly])+label,
.md-form.md-outline input[type=search]:focus:not([readonly])+label,
.md-form.md-outline input[type=tel]:focus:not([readonly])+label,
.md-form.md-outline input[type=text]:focus:not([readonly])+label,
.md-form.md-outline input[type=time]:focus:not([readonly])+label,
.md-form.md-outline input[type=url]:focus:not([readonly])+label,
.md-form.md-outline textarea:focus:not([readonly])+label {
    color: #4285f4
}

.white-text {
    color: #fff !important
}

.md-form .prefix {
    position: absolute;
    -webkit-transition: color .2s;
    -o-transition: color .2s;
    transition: color .2s
}

.md-form.form-lg .validate {
    margin-bottom: 2.8rem
}

.md-form.form-lg label {
    font-size: 1.25rem
}

.md-form.form-lg label.active {
    font-size: .95rem
}

.md-form.form-lg .prefix {
    top: .4rem;
    font-size: 2rem
}

.md-form.form-lg .prefix~input,
.md-form.form-lg .prefix~textarea {
    margin-left: 3rem;
    width: calc(100% - 3rem)
}

.md-form.form-lg .prefix~label {
    margin-left: 3rem
}

.md-form.form-lg .prefix~.form-text {
    margin-left: 3.1rem
}

.md-form.form-sm .validate {
    margin-bottom: 2.3rem
}

.md-form.form-sm label {
    font-size: .875rem
}

.md-form.form-sm label.active {
    font-size: .75rem
}

.md-form.form-sm .prefix {
    top: .35rem;
    font-size: 1.5rem
}

.md-form.form-sm .prefix~input,
.md-form.form-sm .prefix~textarea {
    margin-left: 2rem;
    width: calc(100% - 2rem)
}

.md-form.form-sm .prefix~.form-text,
.md-form.form-sm .prefix~label {
    margin-left: 2rem
}

.md-form textarea.md-textarea {
    overflow-y: hidden;
    padding: 1.5rem 0;
    resize: none
}

.md-form textarea.md-textarea-auto {
    padding: 1.5rem 0 0
}

.md-form.md-outline {
    position: relative;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem
}

.md-form.md-outline input[type=date],
.md-form.md-outline input[type=datetime-local],
.md-form.md-outline input[type=email],
.md-form.md-outline input[type=number],
.md-form.md-outline input[type=password],
.md-form.md-outline input[type=search-md],
.md-form.md-outline input[type=search],
.md-form.md-outline input[type=tel],
.md-form.md-outline input[type=text],
.md-form.md-outline input[type=time],
.md-form.md-outline input[type=url],
.md-form.md-outline textarea {
    -webkit-transition: all .3s;
    -o-transition: all .3s;
    transition: all .3s;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    border: 1px solid #dadce0;
    -webkit-border-radius: 4px;
    border-radius: 4px;
    background-color: transparent;
    -webkit-box-sizing: border-box;
    box-sizing: border-box
}

.md-form.md-outline input[type=date]:focus:not([readonly]),
.md-form.md-outline input[type=datetime-local]:focus:not([readonly]),
.md-form.md-outline input[type=email]:focus:not([readonly]),
.md-form.md-outline input[type=number]:focus:not([readonly]),
.md-form.md-outline input[type=password]:focus:not([readonly]),
.md-form.md-outline input[type=search-md]:focus:not([readonly]),
.md-form.md-outline input[type=search]:focus:not([readonly]),
.md-form.md-outline input[type=tel]:focus:not([readonly]),
.md-form.md-outline input[type=text]:focus:not([readonly]),
.md-form.md-outline input[type=time]:focus:not([readonly]),
.md-form.md-outline input[type=url]:focus:not([readonly]),
.md-form.md-outline textarea:focus:not([readonly]) {
    border-color: #4285f4;
    -webkit-box-shadow: inset 0 0 0 1px #4285f4;
    box-shadow: inset 0 0 0 1px #4285f4
}

.md-form.md-outline input[type=date].valid,
.md-form.md-outline input[type=date]:focus.valid,
.md-form.md-outline input[type=datetime-local].valid,
.md-form.md-outline input[type=datetime-local]:focus.valid,
.md-form.md-outline input[type=email].valid,
.md-form.md-outline input[type=email]:focus.valid,
.md-form.md-outline input[type=number].valid,
.md-form.md-outline input[type=number]:focus.valid,
.md-form.md-outline input[type=password].valid,
.md-form.md-outline input[type=password]:focus.valid,
.md-form.md-outline input[type=search-md].valid,
.md-form.md-outline input[type=search-md]:focus.valid,
.md-form.md-outline input[type=search].valid,
.md-form.md-outline input[type=search]:focus.valid,
.md-form.md-outline input[type=tel].valid,
.md-form.md-outline input[type=tel]:focus.valid,
.md-form.md-outline input[type=text].valid,
.md-form.md-outline input[type=text]:focus.valid,
.md-form.md-outline input[type=time].valid,
.md-form.md-outline input[type=time]:focus.valid,
.md-form.md-outline input[type=url].valid,
.md-form.md-outline input[type=url]:focus.valid,
.md-form.md-outline textarea.valid,
.md-form.md-outline textarea:focus.valid {
    border-color: #00c851;
    -webkit-box-shadow: inset 0 0 0 1px #00c851;
    box-shadow: inset 0 0 0 1px #00c851
}

.md-form.md-outline input[type=date].valid+label:after,
.md-form.md-outline input[type=date]:focus.valid+label:after,
.md-form.md-outline input[type=date]:focus:not([readonly]).valid+label,
.md-form.md-outline input[type=datetime-local].valid+label:after,
.md-form.md-outline input[type=datetime-local]:focus.valid+label:after,
.md-form.md-outline input[type=datetime-local]:focus:not([readonly]).valid+label,
.md-form.md-outline input[type=email].valid+label:after,
.md-form.md-outline input[type=email]:focus.valid+label:after,
.md-form.md-outline input[type=email]:focus:not([readonly]).valid+label,
.md-form.md-outline input[type=number].valid+label:after,
.md-form.md-outline input[type=number]:focus.valid+label:after,
.md-form.md-outline input[type=number]:focus:not([readonly]).valid+label,
.md-form.md-outline input[type=password].valid+label:after,
.md-form.md-outline input[type=password]:focus.valid+label:after,
.md-form.md-outline input[type=password]:focus:not([readonly]).valid+label,
.md-form.md-outline input[type=search-md].valid+label:after,
.md-form.md-outline input[type=search-md]:focus.valid+label:after,
.md-form.md-outline input[type=search-md]:focus:not([readonly]).valid+label,
.md-form.md-outline input[type=search].valid+label:after,
.md-form.md-outline input[type=search]:focus.valid+label:after,
.md-form.md-outline input[type=search]:focus:not([readonly]).valid+label,
.md-form.md-outline input[type=tel].valid+label:after,
.md-form.md-outline input[type=tel]:focus.valid+label:after,
.md-form.md-outline input[type=tel]:focus:not([readonly]).valid+label,
.md-form.md-outline input[type=text].valid+label:after,
.md-form.md-outline input[type=text]:focus.valid+label:after,
.md-form.md-outline input[type=text]:focus:not([readonly]).valid+label,
.md-form.md-outline input[type=time].valid+label:after,
.md-form.md-outline input[type=time]:focus.valid+label:after,
.md-form.md-outline input[type=time]:focus:not([readonly]).valid+label,
.md-form.md-outline input[type=url].valid+label:after,
.md-form.md-outline input[type=url]:focus.valid+label:after,
.md-form.md-outline input[type=url]:focus:not([readonly]).valid+label,
.md-form.md-outline textarea.valid+label:after,
.md-form.md-outline textarea:focus.valid+label:after,
.md-form.md-outline textarea:focus:not([readonly]).valid+label {
    content: attr(data-success);
    color: #00c851;
    opacity: 1
}

.md-form.md-outline input[type=date].invalid,
.md-form.md-outline input[type=date]:focus.invalid,
.md-form.md-outline input[type=datetime-local].invalid,
.md-form.md-outline input[type=datetime-local]:focus.invalid,
.md-form.md-outline input[type=email].invalid,
.md-form.md-outline input[type=email]:focus.invalid,
.md-form.md-outline input[type=number].invalid,
.md-form.md-outline input[type=number]:focus.invalid,
.md-form.md-outline input[type=password].invalid,
.md-form.md-outline input[type=password]:focus.invalid,
.md-form.md-outline input[type=search-md].invalid,
.md-form.md-outline input[type=search-md]:focus.invalid,
.md-form.md-outline input[type=search].invalid,
.md-form.md-outline input[type=search]:focus.invalid,
.md-form.md-outline input[type=tel].invalid,
.md-form.md-outline input[type=tel]:focus.invalid,
.md-form.md-outline input[type=text].invalid,
.md-form.md-outline input[type=text]:focus.invalid,
.md-form.md-outline input[type=time].invalid,
.md-form.md-outline input[type=time]:focus.invalid,
.md-form.md-outline input[type=url].invalid,
.md-form.md-outline input[type=url]:focus.invalid,
.md-form.md-outline textarea.invalid,
.md-form.md-outline textarea:focus.invalid {
    border-color: #f44336;
    -webkit-box-shadow: inset 0 0 0 1px #f44336;
    box-shadow: inset 0 0 0 1px #f44336
}

.md-form.md-outline input[type=date].invalid+label:after,
.md-form.md-outline input[type=date]:focus.invalid+label:after,
.md-form.md-outline input[type=date]:focus:not([readonly]).invalid+label,
.md-form.md-outline input[type=datetime-local].invalid+label:after,
.md-form.md-outline input[type=datetime-local]:focus.invalid+label:after,
.md-form.md-outline input[type=datetime-local]:focus:not([readonly]).invalid+label,
.md-form.md-outline input[type=email].invalid+label:after,
.md-form.md-outline input[type=email]:focus.invalid+label:after,
.md-form.md-outline input[type=email]:focus:not([readonly]).invalid+label,
.md-form.md-outline input[type=number].invalid+label:after,
.md-form.md-outline input[type=number]:focus.invalid+label:after,
.md-form.md-outline input[type=number]:focus:not([readonly]).invalid+label,
.md-form.md-outline input[type=password].invalid+label:after,
.md-form.md-outline input[type=password]:focus.invalid+label:after,
.md-form.md-outline input[type=password]:focus:not([readonly]).invalid+label,
.md-form.md-outline input[type=search-md].invalid+label:after,
.md-form.md-outline input[type=search-md]:focus.invalid+label:after,
.md-form.md-outline input[type=search-md]:focus:not([readonly]).invalid+label,
.md-form.md-outline input[type=search].invalid+label:after,
.md-form.md-outline input[type=search]:focus.invalid+label:after,
.md-form.md-outline input[type=search]:focus:not([readonly]).invalid+label,
.md-form.md-outline input[type=tel].invalid+label:after,
.md-form.md-outline input[type=tel]:focus.invalid+label:after,
.md-form.md-outline input[type=tel]:focus:not([readonly]).invalid+label,
.md-form.md-outline input[type=text].invalid+label:after,
.md-form.md-outline input[type=text]:focus.invalid+label:after,
.md-form.md-outline input[type=text]:focus:not([readonly]).invalid+label,
.md-form.md-outline input[type=time].invalid+label:after,
.md-form.md-outline input[type=time]:focus.invalid+label:after,
.md-form.md-outline input[type=time]:focus:not([readonly]).invalid+label,
.md-form.md-outline input[type=url].invalid+label:after,
.md-form.md-outline input[type=url]:focus.invalid+label:after,
.md-form.md-outline input[type=url]:focus:not([readonly]).invalid+label,
.md-form.md-outline textarea.invalid+label:after,
.md-form.md-outline textarea:focus.invalid+label:after,
.md-form.md-outline textarea:focus:not([readonly]).invalid+label {
    content: attr(data-error);
    color: #f44336;
    opacity: 1
}

.md-form.md-outline input[type=date].form-control.invalid+label:after,
.md-form.md-outline input[type=date].form-control.valid+label:after,
.md-form.md-outline input[type=date].form-control:focus.invalid+label:after,
.md-form.md-outline input[type=date].form-control:focus.valid+label:after,
.md-form.md-outline input[type=datetime-local].form-control.invalid+label:after,
.md-form.md-outline input[type=datetime-local].form-control.valid+label:after,
.md-form.md-outline input[type=datetime-local].form-control:focus.invalid+label:after,
.md-form.md-outline input[type=datetime-local].form-control:focus.valid+label:after,
.md-form.md-outline input[type=email].form-control.invalid+label:after,
.md-form.md-outline input[type=email].form-control.valid+label:after,
.md-form.md-outline input[type=email].form-control:focus.invalid+label:after,
.md-form.md-outline input[type=email].form-control:focus.valid+label:after,
.md-form.md-outline input[type=number].form-control.invalid+label:after,
.md-form.md-outline input[type=number].form-control.valid+label:after,
.md-form.md-outline input[type=number].form-control:focus.invalid+label:after,
.md-form.md-outline input[type=number].form-control:focus.valid+label:after,
.md-form.md-outline input[type=password].form-control.invalid+label:after,
.md-form.md-outline input[type=password].form-control.valid+label:after,
.md-form.md-outline input[type=password].form-control:focus.invalid+label:after,
.md-form.md-outline input[type=password].form-control:focus.valid+label:after,
.md-form.md-outline input[type=search-md].form-control.invalid+label:after,
.md-form.md-outline input[type=search-md].form-control.valid+label:after,
.md-form.md-outline input[type=search-md].form-control:focus.invalid+label:after,
.md-form.md-outline input[type=search-md].form-control:focus.valid+label:after,
.md-form.md-outline input[type=search].form-control.invalid+label:after,
.md-form.md-outline input[type=search].form-control.valid+label:after,
.md-form.md-outline input[type=search].form-control:focus.invalid+label:after,
.md-form.md-outline input[type=search].form-control:focus.valid+label:after,
.md-form.md-outline input[type=tel].form-control.invalid+label:after,
.md-form.md-outline input[type=tel].form-control.valid+label:after,
.md-form.md-outline input[type=tel].form-control:focus.invalid+label:after,
.md-form.md-outline input[type=tel].form-control:focus.valid+label:after,
.md-form.md-outline input[type=text].form-control.invalid+label:after,
.md-form.md-outline input[type=text].form-control.valid+label:after,
.md-form.md-outline input[type=text].form-control:focus.invalid+label:after,
.md-form.md-outline input[type=text].form-control:focus.valid+label:after,
.md-form.md-outline input[type=time].form-control.invalid+label:after,
.md-form.md-outline input[type=time].form-control.valid+label:after,
.md-form.md-outline input[type=time].form-control:focus.invalid+label:after,
.md-form.md-outline input[type=time].form-control:focus.valid+label:after,
.md-form.md-outline input[type=url].form-control.invalid+label:after,
.md-form.md-outline input[type=url].form-control.valid+label:after,
.md-form.md-outline input[type=url].form-control:focus.invalid+label:after,
.md-form.md-outline input[type=url].form-control:focus.valid+label:after,
.md-form.md-outline textarea.form-control.invalid+label:after,
.md-form.md-outline textarea.form-control.valid+label:after,
.md-form.md-outline textarea.form-control:focus.invalid+label:after,
.md-form.md-outline textarea.form-control:focus.valid+label:after {
    top: 2.75rem;
    left: 0;
    position: absolute
}

.md-form.md-outline>input[type=time]:not(.browser-default)+label,
.md-form.md-outline>input[type]:-webkit-autofill:not(.browser-default):not([type=search])+label {
    -webkit-transform: translateY(-17px);
    transform: translateY(-17px);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    background: #fff;
    font-weight: 500;
    padding-right: 5px;
    padding-left: 5px;
    font-size: 11px;
    left: 8px
}

.md-form.md-outline>input[type=time]:not(.browser-default)+label.active,
.md-form.md-outline>input[type]:-webkit-autofill:not(.browser-default):not([type=search])+label.active {
    -webkit-transform: translateY(-17px);
    transform: translateY(-17px);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0
}

.md-form.md-outline .form-control {
    padding: .375rem .75rem
}

.md-form.md-outline label {
    font-size: .875rem;
    position: absolute;
    top: .65rem;
    left: 0;
    padding-left: 10px;
    -webkit-transition: .2s ease-out;
    -o-transition: .2s ease-out;
    transition: .2s ease-out;
    cursor: text;
    color: #757575
}

.md-form.md-outline label.active {
    -webkit-transform: translateY(-100%);
    -ms-transform: translateY(-100%);
    transform: translateY(-100%);
    background: #fff;
    font-weight: 500;
    padding-right: 5px;
    padding-left: 5px;
    font-size: 11px;
    left: 8px
}

.md-form.md-outline.form-lg .form-control.form-control-lg {
    padding: .5rem .725rem
}

.md-form.md-outline.form-lg label {
    font-size: 1.25rem
}

.md-form.md-outline.form-lg label.active {
    -webkit-transform: translateY(-100%);
    -ms-transform: translateY(-100%);
    transform: translateY(-100%);
    font-size: 13px
}

.md-form.md-outline.form-lg .prefix {
    top: .65rem;
    font-size: 25px
}

.md-form.md-outline.form-lg .prefix~input,
.md-form.md-outline.form-lg .prefix~textarea {
    margin-left: 2.2rem;
    width: calc(100% - 2.2rem)
}

.md-form.md-outline.form-lg .prefix~label {
    margin-left: 2.2rem
}

.md-form.md-outline.form-lg .prefix~.form-text {
    margin-left: 2.3rem
}

.md-form.md-outline.form-sm .form-control.form-control-sm {
    padding: .25rem .625rem
}

.md-form.md-outline.form-sm label {
    font-size: .8rem;
    top: .4rem
}

.md-form.md-outline.form-sm label.active {
    -webkit-transform: translateY(-85%);
    -ms-transform: translateY(-85%);
    transform: translateY(-85%);
    font-size: 10px
}

.md-form.md-outline.form-sm .prefix {
    top: .5rem;
    font-size: 15px
}

.md-form.md-outline.form-sm .prefix~input,
.md-form.md-outline.form-sm .prefix~textarea {
    margin-left: 1.6rem;
    width: calc(100% - 1.6rem)
}

.md-form.md-outline.form-sm .prefix~label {
    margin-left: 1.6rem
}

.md-form.md-outline.form-sm .prefix~.form-text {
    margin-left: 1.7rem
}

.md-form.md-outline .prefix {
    position: absolute;
    -webkit-transition: color .2s;
    -o-transition: color .2s;
    transition: color .2s;
    top: .6rem;
    font-size: 20px
}

.md-form.md-outline .prefix:focus {
    color: #4285f4
}

.md-form.md-outline .prefix~input,
.md-form.md-outline .prefix~textarea {
    margin-left: 2rem;
    width: calc(100% - 2rem)
}

.md-form.md-outline .prefix~label {
    margin-left: 2rem
}

.md-form.md-outline .prefix~.form-text {
    margin-left: 2.1rem
}

.md-form.md-outline .character-counter {
    margin-top: -.5rem
}

.md-form.md-ver {
    position: relative;
    padding-top: 16px;
    margin-bottom: 16px
}

.md-form.md-ver input[type=date]:focus,
.md-form.md-ver input[type=datetime-local]:focus,
.md-form.md-ver input[type=email]:focus,
.md-form.md-ver input[type=number]:focus,
.md-form.md-ver input[type=password]:focus,
.md-form.md-ver input[type=search-md]:focus,
.md-form.md-ver input[type=search]:focus,
.md-form.md-ver input[type=tel]:focus,
.md-form.md-ver input[type=text]:focus,
.md-form.md-ver input[type=time]:focus,
.md-form.md-ver input[type=url]:focus,
.md-form.md-ver textarea:focus {
    -webkit-box-shadow: none;
    box-shadow: none;
    border-bottom-color: rgba(0, 0, 0, .12)
}

.md-form.md-ver input[type=date]:focus~label,
.md-form.md-ver input[type=datetime-local]:focus~label,
.md-form.md-ver input[type=email]:focus~label,
.md-form.md-ver input[type=number]:focus~label,
.md-form.md-ver input[type=password]:focus~label,
.md-form.md-ver input[type=search-md]:focus~label,
.md-form.md-ver input[type=search]:focus~label,
.md-form.md-ver input[type=tel]:focus~label,
.md-form.md-ver input[type=text]:focus~label,
.md-form.md-ver input[type=time]:focus~label,
.md-form.md-ver input[type=url]:focus~label,
.md-form.md-ver textarea:focus~label {
    top: 0;
    opacity: 1;
    color: #8e44ad;
    font-size: 12px
}

.md-form.md-ver input[type=date]:focus~label:after,
.md-form.md-ver input[type=datetime-local]:focus~label:after,
.md-form.md-ver input[type=email]:focus~label:after,
.md-form.md-ver input[type=number]:focus~label:after,
.md-form.md-ver input[type=password]:focus~label:after,
.md-form.md-ver input[type=search-md]:focus~label:after,
.md-form.md-ver input[type=search]:focus~label:after,
.md-form.md-ver input[type=tel]:focus~label:after,
.md-form.md-ver input[type=text]:focus~label:after,
.md-form.md-ver input[type=time]:focus~label:after,
.md-form.md-ver input[type=url]:focus~label:after,
.md-form.md-ver textarea:focus~label:after {
    visibility: visible;
    width: 100%;
    left: 0
}

.md-form.md-ver input[type=date]:focus:not([readonly]),
.md-form.md-ver input[type=datetime-local]:focus:not([readonly]),
.md-form.md-ver input[type=email]:focus:not([readonly]),
.md-form.md-ver input[type=number]:focus:not([readonly]),
.md-form.md-ver input[type=password]:focus:not([readonly]),
.md-form.md-ver input[type=search-md]:focus:not([readonly]),
.md-form.md-ver input[type=search]:focus:not([readonly]),
.md-form.md-ver input[type=tel]:focus:not([readonly]),
.md-form.md-ver input[type=text]:focus:not([readonly]),
.md-form.md-ver input[type=time]:focus:not([readonly]),
.md-form.md-ver input[type=url]:focus:not([readonly]),
.md-form.md-ver textarea:focus:not([readonly]) {
    border-color: #4285f4;
    -webkit-box-shadow: inset 0 0 0 1px #4285f4;
    box-shadow: inset 0 0 0 1px #4285f4
}

.md-form.md-ver input[type=date]:focus:not([readonly])+label,
.md-form.md-ver input[type=datetime-local]:focus:not([readonly])+label,
.md-form.md-ver input[type=email]:focus:not([readonly])+label,
.md-form.md-ver input[type=number]:focus:not([readonly])+label,
.md-form.md-ver input[type=password]:focus:not([readonly])+label,
.md-form.md-ver input[type=search-md]:focus:not([readonly])+label,
.md-form.md-ver input[type=search]:focus:not([readonly])+label,
.md-form.md-ver input[type=tel]:focus:not([readonly])+label,
.md-form.md-ver input[type=text]:focus:not([readonly])+label,
.md-form.md-ver input[type=time]:focus:not([readonly])+label,
.md-form.md-ver input[type=url]:focus:not([readonly])+label,
.md-form.md-ver textarea:focus:not([readonly])+label {
    top: 0;
    opacity: 1;
    color: #8e44ad;
    font-size: 12px
}

.md-form.md-ver input[type=date]:focus:not([readonly])+label:after,
.md-form.md-ver input[type=datetime-local]:focus:not([readonly])+label:after,
.md-form.md-ver input[type=email]:focus:not([readonly])+label:after,
.md-form.md-ver input[type=number]:focus:not([readonly])+label:after,
.md-form.md-ver input[type=password]:focus:not([readonly])+label:after,
.md-form.md-ver input[type=search-md]:focus:not([readonly])+label:after,
.md-form.md-ver input[type=search]:focus:not([readonly])+label:after,
.md-form.md-ver input[type=tel]:focus:not([readonly])+label:after,
.md-form.md-ver input[type=text]:focus:not([readonly])+label:after,
.md-form.md-ver input[type=time]:focus:not([readonly])+label:after,
.md-form.md-ver input[type=url]:focus:not([readonly])+label:after,
.md-form.md-ver textarea:focus:not([readonly])+label:after {
    visibility: visible;
    width: 100%;
    left: 0
}

.md-form.md-ver label {
    position: absolute;
    top: 20px;
    left: 0;
    bottom: 0;
    z-index: 2;
    width: 100%;
    font-weight: 300;
    opacity: .5;
    cursor: text;
    -webkit-transition: .2s ease all;
    -o-transition: .2s ease all;
    transition: .2s ease all;
    margin: 0;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.md-form.md-ver label:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 45%;
    height: 2px;
    width: 10px;
    visibility: hidden;
    background-color: #8e44ad;
    -webkit-transition: .2s ease all;
    -o-transition: .2s ease all;
    transition: .2s ease all
}

.md-form.md-ver .form-control {
    position: relative;
    z-index: 1;
    -webkit-border-radius: 0;
    border-radius: 0;
    border-width: 0 0 1px;
    border-bottom-color: rgba(0, 0, 0, .25);
    height: auto;
    padding: 3px 0 5px
}

.md-form.md-ver .form-control:focus {
    -webkit-box-shadow: none;
    box-shadow: none;
    border-bottom-color: rgba(0, 0, 0, .12)
}

.md-form.md-ver .form-control:focus~label {
    top: 0;
    opacity: 1;
    color: #8e44ad;
    font-size: 12px
}

.md-form.md-ver .form-control:focus~label:after {
    visibility: visible;
    width: 100%;
    left: 0
}

.md-form .form-control.is-invalid,
.md-form .form-control.is-valid,
.was-validated .md-form .form-control:invalid,
.was-validated .md-form .form-control:valid {
    padding-right: 0
}
</style>